import React, { useEffect } from "react";
import { useLocation, Link } from "react-router-dom";
import VisualizerBackground from "../components/VisualizerBackground";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error(
      "404 Error: User attempted to access non-existent route:",
      location.pathname
    );
  }, [location.pathname]);

  return (
    <div className="min-h-screen bg-drummer-dark text-white">
      <VisualizerBackground />
      
      <div className="container mx-auto px-4 py-20 min-h-screen flex flex-col items-center justify-center">
        <h1 className="text-8xl md:text-9xl font-bold mb-6 text-transparent bg-clip-text bg-visual-gradient">
          404
        </h1>
        <p className="text-2xl md:text-3xl text-gray-300 mb-8">
          Looks like this beat dropped out
        </p>
        <p className="text-lg text-gray-400 mb-10 max-w-md text-center">
          The page you're looking for doesn't exist or has been moved to a different rhythm.
        </p>
        <Link to="/" className="drum-button">
          Back to Homepage
        </Link>
      </div>
    </div>
  );
};

export default NotFound;
